exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-coupon .delete-content[data-v-8c67cbbe]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.delete-coupon .delete-content .delete-icon[data-v-8c67cbbe]{color:#f56c6c;font-size:5rem;margin-right:10px}", ""]);

// exports
